import { render, staticRenderFns } from "./FormResearch1.vue?vue&type=template&id=11857db4&"
import script from "./FormResearch1.vue?vue&type=script&lang=js&"
export * from "./FormResearch1.vue?vue&type=script&lang=js&"
import style1 from "./FormResearch1.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports